import React from 'react';

const Actions = () => {
    return (
        <div>

        </div>
    );
};

export default Actions;